// extracted by mini-css-extract-plugin
export default {"highlight_span":"useDocumentViewer_highlight_span__vhLTt","highlight_pdf_chunk":"useDocumentViewer_highlight_pdf_chunk__hwqFc"};